/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Base_NameInputs */

const en_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const id_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penelusuran`)
};

const ms_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carian`)
};

const ca_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const cs_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const da_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søgning`)
};

const de_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const et_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otsi`)
};

const es_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscador`)
};

const fr_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche`)
};

const hr_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pretraži`)
};

const it_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricerca`)
};

const lv_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meklēšana`)
};

const lt_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ieškoti`)
};

const hu_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keresés `)
};

const nl_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const nb_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søk`)
};

const pl_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const pt_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisa`)
};

const ro_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const sk_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyhľadávanie`)
};

const sl_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iskanje`)
};

const fi_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haku`)
};

const sv_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök`)
};

const vi_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm`)
};

const tr_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arama`)
};

const el_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αναζήτηση`)
};

const bg_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Търсене`)
};

const ru_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск`)
};

const sr_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Претрага`)
};

const uk_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук`)
};

const ka_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ძიება`)
};

const hi_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const th_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const ko_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`검색`)
};

const zh_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索`)
};

const zh_tw_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜尋`)
};

const ja_search_base_name = /** @type {(inputs: Search_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

/**
* | output |
* | --- |
* | "Search" |
*
* @param {Search_Base_NameInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const search_base_name = /** @type {((inputs?: Search_Base_NameInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Base_NameInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_base_name(inputs)
	if (locale === "ms") return ms_search_base_name(inputs)
	if (locale === "ca") return ca_search_base_name(inputs)
	if (locale === "cs") return cs_search_base_name(inputs)
	if (locale === "da") return da_search_base_name(inputs)
	if (locale === "de") return de_search_base_name(inputs)
	if (locale === "et") return et_search_base_name(inputs)
	if (locale === "es") return es_search_base_name(inputs)
	if (locale === "fr") return fr_search_base_name(inputs)
	if (locale === "hr") return hr_search_base_name(inputs)
	if (locale === "it") return it_search_base_name(inputs)
	if (locale === "lv") return lv_search_base_name(inputs)
	if (locale === "lt") return lt_search_base_name(inputs)
	if (locale === "hu") return hu_search_base_name(inputs)
	if (locale === "nl") return nl_search_base_name(inputs)
	if (locale === "nb") return nb_search_base_name(inputs)
	if (locale === "pl") return pl_search_base_name(inputs)
	if (locale === "pt") return pt_search_base_name(inputs)
	if (locale === "ro") return ro_search_base_name(inputs)
	if (locale === "sk") return sk_search_base_name(inputs)
	if (locale === "sl") return sl_search_base_name(inputs)
	if (locale === "fi") return fi_search_base_name(inputs)
	if (locale === "sv") return sv_search_base_name(inputs)
	if (locale === "vi") return vi_search_base_name(inputs)
	if (locale === "tr") return tr_search_base_name(inputs)
	if (locale === "el") return el_search_base_name(inputs)
	if (locale === "bg") return bg_search_base_name(inputs)
	if (locale === "ru") return ru_search_base_name(inputs)
	if (locale === "sr") return sr_search_base_name(inputs)
	if (locale === "uk") return uk_search_base_name(inputs)
	if (locale === "ka") return ka_search_base_name(inputs)
	if (locale === "hi") return hi_search_base_name(inputs)
	if (locale === "th") return th_search_base_name(inputs)
	if (locale === "ko") return ko_search_base_name(inputs)
	if (locale === "zh") return zh_search_base_name(inputs)
	if (locale === "zh-tw") return zh_tw_search_base_name(inputs)
	if (locale === "ja") return ja_search_base_name(inputs)
	return en_search_base_name(inputs)
});